import { Box, Progress } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var LoadingBar = function LoadingBar() {
  return /*#__PURE__*/_jsx(Box, {
    zIndex: 99,
    top: 0,
    left: 0,
    right: 0,
    pos: "absolute",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    borderTopRadius: "md",
    overflow: "hidden",
    e2eid: "CrudTable_LoadingBar_Box",
    children: /*#__PURE__*/_jsx(Progress, {
      size: "xs",
      isIndeterminate: true,
      e2eid: "CrudTable_LoadingBar_Progress"
    })
  });
};